import { render, staticRenderFns } from "./waitlist.vue?vue&type=template&id=ca0d5dae&scoped=true&"
import script from "./waitlist.vue?vue&type=script&lang=js&"
export * from "./waitlist.vue?vue&type=script&lang=js&"
import style0 from "./waitlist.vue?vue&type=style&index=0&id=ca0d5dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0d5dae",
  null
  
)

export default component.exports